"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localStorageSetDataDirect = async ({ entryVars: { path, data, }, callbacks, executeProcesses, functionId, processor, }) => {
    if (typeof path !== 'string' || !path) {
        processor.root.alert('Invalid path to set data db local direct', `${path}`);
        executeProcesses(functionId, callbacks.errorProcess, 'Invalid path');
        return;
    }
    processor.root.localStorage.update({
        [path]: data,
    });
    executeProcesses(undefined, callbacks.successProcess);
};
exports.default = localStorageSetDataDirect;
